<template>
  <custom-dialog
    width="1400px"
    :title="model.title"
    :visible="visible"
    v-on="$listeners"
    class="replace-part-dialog"
    :appendToBody="true"
  >
    <div class="dialog-body">
      <div class="search-hd">
        <el-form
          :inline="true"
          @submit.native.prevent
        >
          <el-form-item>
            <div class="item-title">{{ $t('crm_replace_part_dialog.xzxghpj') }}</div>
          </el-form-item>
          <!-- 搜索栏 -->
          <el-form-item style="float: right; margin-right: 0">
            <search-input
              v-model="search"
              :placeholder="$t('crm_replace_part_dialog.ji_shen_hao')"
              @fetch="onFetch"
            ></search-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-bd">
        <custom-table
          tableCode="free_acc_order_replace_part"
          :data="tableData"
          :slots="['erpCode', 'action']"
        >
          <template v-slot:erpCode="scope">
            <custom-select
              v-model="scope.row.erpCode"
              url="giveawaySelect"
              :props="{label: 'label', value: 'erpCode'}"
              :params="{orderGiveawayId: scope.row.orderGiveawayId, orderGoodsRuleId: scope.row.orderGoodsRuleId}"
              :clearable="false"
              :dataFilter="selectFilter"
              @change="selectChange($event,scope.row)"
            ></custom-select>
          </template>
          <template v-slot:action="scope">
            <el-button
              type="text"
              size="mini"
              @click="onDelRow(scope.row)"
            >{{ $t('Common.com_delete') }}</el-button>
          </template>
        </custom-table>
      </div>
      <div class="table-page">
        <div class="table-sum-params">
          <div class="sum-item">
            <div class="key">{{ $t('crm_replace_part_dialog.zeng_song_shu_liang') }}：</div>
            <div class="val selected-num">{{ giveNum }}</div>
          </div>
        </div>
        <custom-page
          :total="tableData.length"
          :page="pageNum"
          :size="pageSize"
          @change="onPageChange"
        ></custom-page>
      </div>
    </div>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="visible = false">{{ $t('Common.com_cancel') }}</el-button>
      <el-button
        type="primary"
        @click="onConfirm"
        :disabled="!data.length"
      >{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      // 搜索keyword - 本地使用
      search: '',
      actualSearch: '',
      data: [],
      pageSize: 8,
      pageNum: 1,
    };
  },
  computed: {
    tableData() {
      return this.getPageData(this.pageNum, this.pageSize, this.actualSearch);
    },
    // 赠送数量
    giveNum() {
      return this.data.reduce((total, obj) => total + obj.bookingNum || 0, 0);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    selectChange(newData, row) {
      const keys = ['erpCode', 'goodsCode', 'goodsName', 'goodsSpec', 'unit'];
      keys.forEach((key) => {
        const val = newData[key];
        row[key] = val;
      });
    },
    selectFilter(list) {
      return list.map((item) => {
        const obj = {
          ...item,
        };
        obj.label = [obj.erpCode, obj.goodsName].join('/');
        return obj;
      });
    },
    init() {
      const copyData = this.model.data.map((item) => {
        const obj = {
          ...item,
        };
        obj.erpCode = '';
        return obj;
      });

      this.data = [...copyData];
    },
    onDelRow(row) {
      this.$showConfirm(this.$t('crm_replace_part_dialog.nqdscgpjm')).then(() => {
        this.data = this.data.filter((item) => item.orderGoodsPartId !== row.orderGoodsPartId);
      });
    },
    onConfirm() {
      const hasEmptyCode = this.data.some((item) => !item.erpCode);

      if (hasEmptyCode) {
        this.$message({
          message: this.$t('crm_replace_part_dialog.qxzghhpj'),
          type: 'error',
        });
        return;
      }

      this.$postJSON(apis.giveawayReplace, this.data).then(() => {
        this.$message({
          message: this.$t('Common.com_handle_success'),
          type: 'success',
        });
        this.$emit('confirm');
        this.close();
      });
    },
    close() {
      this.$emit('close');
    },
    getPageData(pageNum, pageSize, keyword) {
      const data = [...this.data];
      const startIndex = (pageNum - 1) * pageSize;
      if (keyword) {
        const searchKey = 'bodyNum'; // 开发环境应该是bodyNum
        const list = this.fuzzyQuery(data, [searchKey], keyword);
        return list.splice(startIndex, pageSize);
      }
      return data.splice(startIndex, pageSize);
    },

    onFetch() {
      this.actualSearch = this.search;
      this.onPageChange({ page: 1 });
    },

    // 分页变更
    onPageChange: function ({ page, size }) {
      this.pageNum = page;
      this.pageSize = size || this.pageSize;
    },
  },
};
</script>

<style lang="scss" scoped>
.replace-part-dialog {
  .dialog-body {
    padding-bottom: 0 !important;
  }

  .table-sum-params {
    float: left;
    overflow: hidden;

    .selected-num {
      padding: 0 5px;
      color: #0d9ae0;
    }

    .sum,
    .price {
      color: #0d9ae0;
    }

    .ml-10 {
      margin-left: 10px;
    }

    .sum-item {
      float: left;
      line-height: 32px;
      font-size: 12px;
      color: #606266;

      .key,
      .val {
        float: left;
      }
    }
  }

  .search-hd {
    padding-top: 0;
  }
}
</style>
